/* eslint-disable */

export const switchStatusDepthConstants = {
    SWITCH_STATUS_DEPTH_REQUEST: 'SWITCH_STATUS_DEPTH_REQUEST',
    SWITCH_STATUS_DEPTH_SUCCESS: 'SWITCH_STATUS_DEPTH_SUCCESS',
    SWITCH_STATUS_DEPTH_FAILURE: 'SWITCH_STATUS_DEPTH_FAILURE',
};
